import React from "react";
import { Link } from "react-router-dom";

/**
 * Componente de miga de pan (breadcrumb) utilizado para mostrar la ruta
 * de navegación
 *
 * Cada elemento puede representarse como un enlace o como texto plano.
 * El último elemento se considera la página actual y se renderiza sin enlace,
 * incluyendo el atributo `aria-current="page"` para mejorar la accesibilidad.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Array<Object>} [props.items=[]] - Elementos que conforman la miga de pan.
 * @param {string} props.items[].label - Texto que se mostrará para cada elemento.
 * @param {string} [props.items[].to] - Ruta de navegación. Si no se proporciona, el elemento se renderiza como texto sin enlace.
 * @returns {JSX.Element|null} Breadcrumb
 */
export const Breadcrumb = ({ items = [] }) => {
    if (!items.length) return null;

    return (
        <nav className="breadcrumb--general" aria-label="Miga de pan">
            <ol className="breadcrumb__list">
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    return (
                        <li
                            key={`${item.label}-${index}`}
                            className="breadcrumb__item"
                            aria-current={isLast ? "page" : undefined}
                        >
                            {isLast || !item.to ? (
                                <span>{item.label}</span>
                            ) : (
                                <Link to={item.to}>{item.label}</Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};